import { observer } from 'mobx-react';
import { Check } from 'office-ui-fabric-react/lib/components/Check';
import { FileIcon } from 'owa-file-icon';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import * as React from 'react';

const styles = require('./ItemTileView.scss');
const classNames = require('classnames');

export interface ItemTileViewPropsBase {
    itemIndex: number;
    itemType: number;
    isSelected: boolean;
    primaryText: string;
    location: string;
    ariaLabel: string;
    icon: FileIcon;
    secondaryText?: string;
    className?: string;
    onSelectedClassName?: string;
}

export interface ItemTileViewProps extends ItemTileViewPropsBase {
    children?: JSX.Element;
    shouldShowTileOverlay?: boolean;
}

@observer
export default class ItemTileView extends React.Component<ItemTileViewProps, {}> {
    private tileContainer: HTMLDivElement;

    render() {
        // If the overlay is not shown the child container takes up the whole width and height otherwise it just takes whats available
        const childContainerClassName = this.props.shouldShowTileOverlay
            ? styles.childContainerPartial
            : styles.childContainerFull;
        const checkboxClassNames = classNames([
            styles.checkbox,
            this.props.isSelected && styles.showCheckbox,
        ]);

        const tilePrimaryTextOverlayClassName = classNames([
            styles.tilePrimaryTextOverlay,
            this.props.isSelected && styles.tilePrimaryTextOverlayOnSelected,
        ]);

        const tileSecondaryTextOverlayClassName = classNames([
            styles.tileSecondaryTextOverlay,
            this.props.isSelected && styles.tileSecondaryTextOverlayOnSelected,
        ]);

        const itemTitle =
            this.props.itemType === AttachmentDataProviderType.OneDrivePro
                ? this.props.location
                : this.props.primaryText;

        return (
            <div
                ref={ref => (this.tileContainer = ref)}
                className={classNames([
                    styles.container,
                    this.props.className,
                    this.props.isSelected && this.props.onSelectedClassName,
                ])}
                aria-label={this.props.ariaLabel}
                data-is-focusable={true}
                tabIndex={-1}
                data-selection-index={this.props.itemIndex}
                title={itemTitle}>
                <div className={styles.tile}>
                    {/* The checkbox on the tile */}
                    <div className={checkboxClassNames} data-selection-toggle={true}>
                        <Check checked={this.props.isSelected} />
                    </div>

                    <div
                        className={childContainerClassName}
                        data-is-focusable={false}
                        onMouseDown={this.focusOnTileViewOnMouseDown}>
                        {this.props.children}
                    </div>

                    {/* The tile overlay */}
                    {this.props.shouldShowTileOverlay && (
                        <div className={styles.tileOverlay}>
                            <div className={tilePrimaryTextOverlayClassName}>
                                {' '}
                                {this.props.primaryText}{' '}
                            </div>
                            {this.props.secondaryText && (
                                <div className={tileSecondaryTextOverlayClassName}>
                                    {' '}
                                    {this.props.secondaryText}{' '}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    componentDidMount() {
        if (this.props.itemIndex === 0) {
            this.focus();
        }
    }

    focus() {
        this.tileContainer.focus();
    }

    private focusOnTileViewOnMouseDown = (evt: React.MouseEvent<unknown>) => {
        // If a click happens on the child container then we need to change the focus
        // back to the parent container of the tile view.
        evt.stopPropagation();
        evt.preventDefault();
        this.focus();
    };
}
